module.exports = "<div class=\"container\">\n\n  <p class=\"title app-title\">{{message}}</p>\n\n  <img class=\"icon\" src=\"{{iconUrl}}\"/>\n\n\n</div>\n"